import colors from '../../../../../public/colors'


export default theme => {
    const mode = theme?.palette?.mode || 'light'
    // const themeColors = colors[mode] || colors.light || {}


    return {
        button: {
            '&.MuiButton-root': {
                backgroundColor: '#FEDF01',
                borderRadius: '2px',
                boxShadow: 'none',
                boxSizing: 'border-box',                
                color: '#003168',
                height: '32px',
                width: 'auto'
            }
        },
        buttonContainer: {
            display: 'flex',
            justifyContent: 'flex-end',
            paddingLeft: '90%',
        
            [theme.breakpoints.down('sm')]: {
                paddingLeft: '75%',
            },
            [theme.breakpoints.down('xs')]: {
                paddingLeft: '70%',
            }
        },
        buttonFrench: {
            '&.MuiButton-root': {
                width: 'auto'
            }
        },
        cardContainer: {
            display: 'flex',
            flexDirection: 'column',
            minHeight: '481px',
            width: '650px',
            [theme.breakpoints.down('md')]: {
                maxWidth: '100%',
                width: '100%'
            },
            [theme.breakpoints.down('sm')]: {
                minHeight: 'auto',
                width: '100%'
            }
        },
        content: {
            background: theme.palette.mode === 'dark' ? '#101935' : '#FFFFFF',
            border: theme.palette.mode === 'dark' ? '1px solid rgba(255, 255, 255, 0.1)' : 'none',
            minHeight: '361px',
            width: '100%',
            [theme.breakpoints.down('sm')]: {
                minHeight: 'auto'
            }
        },
        contentInner: {
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            gap: '32px',
            padding: theme.palette.mode === 'dark' ? '24px 24px 32px' : '24px',
            [theme.breakpoints.down('sm')]: {
                gap: '20px',
                padding: '16px'
            }
        },
        footerActions: {
            alignItems: 'center',
            display: 'flex',
            height: '32px',
            justifyContent: 'flex-end',
            width: '100%',
            [theme.breakpoints.down('sm')]: {
                height: 'auto'
            }
        },
        helpText: {
            color: colors[mode].cardDescription,
            fontSize: '14px',
            letterSpacing: '0.17px',
            lineHeight: '20px',
            width: '100%',
            [theme.breakpoints.down('sm')]: {
                fontSize: '12px',
                lineHeight: '18px'
            }
        },
        stepCard: {
            background: theme.palette.mode === 'dark' ? '#101935' : '#FFFFFF',
            border: theme.palette.mode === 'dark' ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid #E1E4E5',
            borderRadius: '4px',
            boxShadow: 'none',
            boxSizing: 'border-box',
            height: '172px',
            width: '190px',
            [theme.breakpoints.down('sm')]: {
                height: 'auto',
                minHeight: '140px',
                width: '100%'
            }
        },
        stepContent: {
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            padding: 0,
            [theme.breakpoints.down('sm')]: {
                gap: '6px',
                padding: '12px'
            }
        },
        stepDescription: {
            color: colors[mode].cardDescription,
            fontSize: '14px',
            letterSpacing: '0.17px',
            lineHeight: '20px',
            textAlign: 'center',
            [theme.breakpoints.down('sm')]: {
                fontSize: '12px',
                lineHeight: '18px'
            }
        },
        stepDivider: {
            border: theme.palette.mode === 'dark' ? '1px dashed rgba(255, 255, 255, 0.1)' : '1px dashed #E1E4E5',
            height: 0,
            [theme.breakpoints.down('sm')]: {
                display: 'none'
            }
        },
        stepHeader: {
            display: 'flex',
            gap: '3px',
            height: '24px',
            justifyContent: 'center',
            [theme.breakpoints.down('sm')]: {
                marginBottom: '4px'
            }
        },
        stepNumber: {
            alignItems: 'center',
            background: colors[mode].welcomeCardStepLabel,
            borderRadius: '100px',
            color: colors[mode].welcomeCardStepLabelText,
            display: 'flex',
            fontSize: '12px',
            height: '24px',
            justifyContent: 'center',
            letterSpacing: '0.4px',
            minHeight: '24px',
            minWidth: '24px',
            textAlign: 'center',
            width: '24px',
            [theme.breakpoints.down('sm')]: {
                fontSize: '11px',
                height: '20px',
                minHeight: '20px',
                minWidth: '20px',
                width: '20px'
            }
        },
        stepsContainer: {
            alignItems: 'center',
            display: 'grid',
            gridTemplateColumns: 'auto 3% auto',
            
            height: '172px',
            justifyContent: 'center',
            width: '100%',
            // [theme.breakpoints.down('md')]: {
            //     gridTemplateColumns: '1fr 1fr 1fr',
            //     height: 'auto',
            //     justifyItems: 'center',
            //     paddingLeft: '2%',
            //     width: '96%'
            // },
            [theme.breakpoints.down('sm')]: {
                gap: '5%',
                gridTemplateColumns: '1fr',
                height: 'auto',
                justifyItems: 'center',
                paddingLeft: '0',
                width: '100%'
            }
        },
        stepTitle: {
            color: theme.palette.mode === 'dark' ? '#FFFFFF' : '#003168',
            fontSize: '14px',
            fontWeight: 500,
            letterSpacing: '0.1px',
            lineHeight: '20px',
            textAlign: 'center',
            [theme.breakpoints.down('sm')]: {
                fontSize: '13px',
                lineHeight: '18px'
            }
        },
        subtitle: {
            color: colors[mode].cardDescription,
            fontSize: '16px',
            letterSpacing: '0.25px',
            lineHeight: '24px',
            width: '100%',
            [theme.breakpoints.down('sm')]: {
                fontSize: '14px',
                lineHeight: '20px'
            }
        },
        textSection: {
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            width: '100%',
            [theme.breakpoints.down('sm')]: {
                gap: '6px'
            }
        },
        warningMessage: {
            color: colors[mode].cardDescription,
            fontSize: '14px',
            letterSpacing: '0.17px',
            lineHeight: '20px',
            width: '100%',
            [theme.breakpoints.down('sm')]: {
                fontSize: '12px',
                lineHeight: '18px'
            }
        }
    }
}